module.exports = __webpack_public_path__ + "al.no1.19eab899.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/al.no1.jpg
// module id = F0O2
// module chunks = 0